var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TagInputField, translate } from '@lucidlink/uicore';
import { useFormRoot, } from '@lucidlink/uicore/form-builder';
import { composeValidators } from '@lucidlink/uicore/form-builder/services';
import { PII_BLOCK_CLASS } from '#constants';
import { emailInviteValidationRules, inviteEmailValidation, membersCountValidation, } from './services/validation';
export const MembersEmailsTagInput = ({ availableSlots, fieldName, label, maxMembers, placeholder, serverErrorCode, }) => {
    _react_refresh_temp_2();
    const { errors } = useFormRoot();
    const composedInviteEmailValidator = useMemo(() => {
        return availableSlots !== null
            ? composeValidators(inviteEmailValidation, membersCountValidation(availableSlots))
            : inviteEmailValidation;
    }, [availableSlots]);
    // TODO: https://lucidlink.atlassian.net/browse/LUCID-17132
    // Currently if an error has the property `isServerError: false`,
    // doesn't mean that the error isn't a server one. It means that the
    // error has been remapped from server error to look like a client error.
    //
    // We want to show only one type of "client error" here, so if there
    // is a server error it takes priority. If there isn't a server error we
    // show the client error message.
    const fieldErrors = errors?.[fieldName];
    const clientErrorMessage = useMemo(() => {
        if (fieldErrors?.some((error) => error.code === 'invitation.emailFilters.empty')) {
            return translate('Provide at least one email address.');
        }
        if (fieldErrors?.some((error) => error.isServerError !== undefined)) {
            return '';
        }
        return translate('There are some issues with the emails you have provided. Hover over each for more details.');
    }, [fieldErrors]);
    return (_jsx(TagInputField, { className: PII_BLOCK_CLASS, clientErrorMessage: clientErrorMessage, "data-testid": fieldName, generalServerErrorCode: serverErrorCode, getTagErrorText: ({ code }) => translate(code), id: fieldName, label: label, name: fieldName, placeholder: placeholder, rules: emailInviteValidationRules(maxMembers), validator: composedInviteEmailValidator }));
};
_react_refresh_temp_1 = MembersEmailsTagInput;
$RefreshReg$(_react_refresh_temp_1, "MembersEmailsTagInput");
_react_refresh_temp_2(MembersEmailsTagInput, "c1a17RcJO+0KgjPmK8ptw5CYP1g=", false, () => [useFormRoot]);
